import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import AdminCalendar from "@/pages/AdminCalendar";

export const Route = createFileRoute("/admin/calendar")({ head: () => routeMeta('Appointment Calendar | MNRE Admin', 'Manage property appointments and staff schedules.', '/admin/calendar'), component: AdminCalendar });
